import { createContext } from 'react'

import defaultProperties from './defaultProperties'

const LoadingContext = createContext(
{
    ...defaultProperties
});

export default LoadingContext ;